import orgServices from '../../../services/notisphere/organization'
import SupplierModal from './SupplierModal'
import SupplierListModal from './SupplierListModal'
import { SUPLLIERLIST_STATUS } from '../../../misc/commons'
import { Notisphere_SupplierList_AgGrid, AG_GridCustomizedTableHeaders_Key } from '../../../misc/tableHeaders'
import _ from 'lodash'

export default {
    components: {
        SupplierModal,
        SupplierListModal
    },
    data() {
        return {
            columnDefs: null,
            gridOptions: {
                onFilterChanged: this.onFilterChanged,
                onSortChanged: this.onSortChanged,
                getContextMenuItems: this.getContextMenuItems,
            },
            searchQuery: { pageNumber: 1, pageSize: 50, sort: null, colId: null },
            total: 0,
            items: [],
            gridApi: null,
            columnApi: null,
            autocompleteItemsdata: [],
            org_status: SUPLLIERLIST_STATUS,
            table_Connection_Data: this.$store.state.CustomizedHeaders.filter(s => s.userId == this.$store.state.user.id)[0],
            supplierModalKey: 0,
            supplierListModalKey: 0,
            dataPhoto: '',
            search: {
                status: null,
            },
        }
    },
    beforeMount() {
        this.columnDefs = Notisphere_SupplierList_AgGrid
    },
    created() {
        this.rowModelType = 'serverSide'
        this.GetSupplierNameList()
    },
    methods: {
        GetSupplierNameList() {

            orgServices.GetSupplierNameList().then((res) => {
                if(res.data.d.length > 0)
                    this.autocompleteItemsdata = []
                for (let i = 0; i < res.data.d.length; i++) {

                    this.autocompleteItemsdata.push(res.data.d[i])
                }
            })
        },
        onCompleted(type) {
            if (type == 'UPDATE') {
                this._showToast('Updated successfully!')
            }
            if (type == 'INSERT') {
                this._showToast('Added successfully!')
            }
            if (type == 'LINKED') {
                this._showToast('Supplier linking successful')
            }
            if (this.gridApi) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            }
            this.GetSupplierNameList()
        },
        addMoreClick() {
            this.supplierModalKey += 1
            this.$nextTick(()=>{
                this.$refs.supplierModal.forceRerenderInsert()
            })
        },
        editSupplier(payload, e = null) {
            this.supplierModalKey += 1
            this.$nextTick(()=>{
                this.$refs.supplierModal.forceRerenderUpdate(payload)
            })
            if (e) {
                e.stopPropagation()
            }
        },

        linkSupplier(payload) {
            this.supplierListModalKey += 1
            var data=this.autocompleteItemsdata.filter(s=>s.id!=payload.id)
            var linkedSupplierName = this.autocompleteItemsdata.filter(s=>s.id==payload.linked_supplier_id)[0]?.text
            this.$nextTick(()=>{
                this.$refs.supplierListModal.forceRerenderSupplierList(payload,data,linkedSupplierName)
            })
        },
        updateSupplier(item, st, e = null) {
            orgServices.updateSupplierList(item, st).then(resp => {
                if (!resp.error) {
                    if (this.gridApi) {
                        this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
                    }
                    this.GetSupplierNameList()
                    if (st == 'ACTIVE') {
                        this._showToast('Supplier is activated!')
                    } else {
                        this._showToast('Supplier is deactivated!')
                    }
                }
            })
            if (e) {
                e.stopPropagation()
            }
        },

        fetchData(params) {
            this.applyState(params)
            this.setFilterModel(params)
            let that = this
            that.gridApi = params.api
            that.columnApi = params.columnApi
            const datasource = {
                getRows(params) {
                    that.search.status = params.request?.filterModel?.status?.values
                    that.searchQuery.colId = params.request?.sortModel[0]?.colId
                    that.searchQuery.sort = params.request?.sortModel[0]?.sort
                    that.search.filterModel = that.gridApi.getFilterModel()
                    orgServices.findSuppliersList({
                        ...that.searchQuery,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        search: that.searchQuery.globalSearch,
                        ...that.search,
                    }).then(resp => {
                        if (!resp.error) {
                            that.total = resp.data.d.t
                            if (that.total == 0) {
                                that.gridApi.showNoRowsOverlay()
                            } else {
                                that.gridApi.hideOverlay()
                            }
                            return resp.data.d.c
                        }
                    }).then(response => {
                        params.successCallback(response)
                    }).catch(error => {
                        console.error(error)
                        params.failCallback()
                    })
                }
            }
            // register datasource with the grid
            params.api.setServerSideDatasource(datasource)
        },
        deletePendingSupplier(item, e) {
            this._showConfirm('You are about to delete this organization, this cannot be undone.').then(confirm => {
                if (confirm) {
                    orgServices.deletePendingSupplier(item.id).then(resp => {
                        if (!resp.error) {
                            if (this.gridApi) {
                                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
                            }
                            this._showToast('Deleted successfully!')
                        }
                    })
                }
            })
            e.stopPropagation()
        },
        showLogoPreview(id) {
            this.dataPhoto = '',
            orgServices.GetKnownSupplierProfile(id).then((res) => {
                if(res.data.d){
                    this.dataPhoto= res.data.d.logo ? 'data:image;base64,' + res.data.d.logo : ''
                }
            })
            this.$bvModal.show('logo-preview-modal')
        },
        async handleFilesUpload() {
            let file = this.$refs.fileimg1.files[0]
            const formData = new FormData()
            formData.append('Logo', file)
            await orgServices.ProcessSupplierFile(formData)
        },
        // AG Grid specific methods
        getContextMenuItems(params) {
            let that = this
            const defaultItems = params.defaultItems
            const filteredItems = defaultItems.filter((item) => item !== 'export')
            const searchquery = JSON.parse(JSON.stringify(this.searchQuery))
            const customMenuItem = {
                name: 'Excel Export',
                action: async function () {
                    const email = that.$store.state.user.email
                    const query_param = {
                        ...searchquery,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        filterModel: params.api.getFilterModel(),
                        search: that.searchQuery.globalSearch,
                        email: email,
                    }
                    const resp = await orgServices.downloadAgGridSupplierListXLSX(query_param)
                    if (!resp.error) {
                        that._showOk(resp.data.d.message, {
                            variant: 'success',
                            title: 'Message',
                            buttonTitle: 'Ok',
                        })
                    }
                },
                icon: '<span class="ag-icon ag-icon-excel"></span>',
            }

            const allItems = [...filteredItems, customMenuItem]
            return allItems
        },
        saveState(params) {
            this.table_Connection_Data.Notisphere_Login.SupplierList_Headers = params.columnApi.getColumnState()
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
        },
        applyState(params) {
            var tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            var columnState = tableState?.Notisphere_Login?.SupplierList_Headers
            if (columnState) {
                params.columnApi.applyColumnState({ state: columnState, applyOrder: true })
            }
        },
        onFilterChanged(event) {
            this.table_Connection_Data.Notisphere_Login.SupplierList_Filters = event.api.getFilterModel()
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
            this.fetchData(event)
        },
        setFilterModel(params) {
            var tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            var filterModel = tableState?.Notisphere_Login?.SupplierList_Filters
            if (filterModel) {
                params.api.setFilterModel(filterModel)
            }
        },
        onSortChanged(event) {
            this.saveState(event)
            this.fetchData(event)
        },
        onCellClicked(params) {
            if (params.colDef.field == 'logo' && params.data.logo) {
                this.showLogoPreview(params.data.id)
                return
            }
            if (params.column.colId === 'actions') {
                if (params.event.target.dataset.action === 'edit') {
                    this.editSupplier(params.data)
                } else if (params.event.target.dataset.action === 'link') {
                    this.linkSupplier(params.data)
                } else if (params.event.target.dataset.action === 'activate') {
                    this.updateSupplier(params.data.id, 'ACTIVE')
                } else if (params.event.target.dataset.action === 'deactivate') {
                    this.updateSupplier(params.data.id, 'DEACTIVATED')
                }
                return
            }
        },
        onGlobalSearchChange(searchValue) {
            // Handle global search - you can implement text search across all columns
            this.searchQuery.globalSearch = searchValue
            if (this.gridApi) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            }
        }
    }
}